import React from 'react';
import Carousel from '@/components/Carousel';
import styles from './index.scss';
import bannerImg1 from '@/assets/images/banners/banner-jcb-202407-1.jpg';
import bannerImg2 from '@/assets/images/banners/banner-20241231.png';
import bannerImg3 from '@/assets/images/banners/banner2412.jpg';
import banner20250729 from '@/assets/images/banners/banner-20250729.png';
import Icon from '@/components/Icon';

export default function HomePage() {
  const serviceItems = [
    {
      name: 'solution',
      title: '赋能金融',
      desc: '以科技创新赋能金融机构，提供全方位的数字化解决方案',
    },
    {
      name: 'security',
      title: '安全保障',
      desc: '严格遵守国家相关法律法规，确保数据安全和业务合规',
    },
    {
      name: 'service',
      title: '专业服务',
      desc: '专业的技术团队和服务团队，为客户提供优质的服务体验',
    },
    {
      name: 'ai',
      title: '创新发展',
      desc: '持续创新，不断探索新技术、新模式，助力金融机构数字化转型',
    },
  ];

  const carouselImages = [
    {
      src: bannerImg1,
      alt: '金融科技解决方案',
      link: '/product/truck-insurance',
    },
    {
      /*  */
      src: bannerImg2,
      alt: '智能保险解决方案',
      link: 'https://haochezhu.zhongan.com/skip?url=/pages/opening/index?bizOrigin=out_technology_company',
    },
    {
      src: bannerImg3,
      alt: '',
    },
    {
      src: banner20250729,
      alt: '众安车生态 保障更全面',
      link: 'https://haochezhu.zhongan.com/skip?url=%2Fpages%2Fopening%2Findex%3FbizOrigin%3Dout_technology_company',
    },
  ];

  /* /product/truck-insurance */
  /* https://haochezhu.zhongan.com/skip?url=/pages/opening/index?bizOrigin=out_technology_company */
  return (
    <div className={styles.container}>
      <div className={styles.carouselWrapper}>
        <Carousel images={carouselImages} />
      </div>

      <div className={styles.service}>
        <div className={styles.title}>
          <h2>我们的服务</h2>
          <p>为金融机构提供全方位的科技解决方案</p>
        </div>
        <div className={styles.wrapper}>
          <ul>
            {serviceItems.map((item, index) => (
              <li key={index}>
                <div className={styles.icon}>
                  <Icon name={item.name} />
                </div>
                <div className={styles.content}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
